import React from 'react';

function About() {
    return (
        <div>
            <h1>About La Pelicula</h1>
            <p>This is a movie recommender system built with React and Blazor.</p>
        </div>
    );
}

export default About;
